export default {
  MuiDateRangePickerDay: {
    styleOverrides: {
      day: {
        '&.Mui-selected': {
          backgroundColor: '#0075FE'
        }
      },
      rangeIntervalDayHighlightStart: {
        backgroundColor: 'rgba(31, 134, 255, 0.2) !important'
      }
    }
  },
  PrivatePickersSlideTransition: {
    styleOverrides: {
      root: {
        minHeight: '225px'
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: '#0075FE'
        },
        '&.Mui-selected:hover': {
          backgroundColor: '#0075FE'
        },
        '&.Mui-selected:focus': {
          backgroundColor: '#0075FE'
        }
      }
    }
  }
};
